export default "__VITE_ASSET__CtTCtwpZ__"